import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import katex from "katex";
import "katex/dist/katex.min.css";
import CustomToolbar from './CustomToolbar';

window.katex = katex;

const Editor = ({ value, onChange, readOnly = false, onReady, isBlog = false }) => {
  const quillRef = useRef(null);
  // const isBlog

  const modules = {
    toolbar: { container: "#toolbar" }
  };

  const formats = [
    'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'header', 'blockquote', 'code-block',
    'indent', 'list',
    'direction', 'align',
    'link', 'image', 'video', 'formula'
  ];

   const placeholder = isBlog
    ? "Write your Blog content here..."
    : "Write your Custom Email content here...";

  //  Expose the real Quill instance to parent
  useEffect(() => {
    if (quillRef.current && onReady) {
      onReady(quillRef.current.getEditor());
    }
  }, [onReady]);

  return (
    <>
      <CustomToolbar />

      <ReactQuill
        ref={quillRef}
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        style={{ height: '150px' }}
        placeholder={placeholder}
        readOnly={readOnly}
      />
    </>
  );
};

export default Editor;
